"use client";

import React, { useId } from "react";

const BREAKPOINTS = ["xs", "sm", "md", "lg", "xl", "xxl"];

const BP_MIN_WIDTH = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

/**
 * Row - flex row with gutters.
 * Supports column-count breakpoints (xs, sm, md, lg, xl, xxl) to control
 * how many children per row at each breakpoint, e.g. <Row xs={1} xl={2}>.
 */
export function Row({ children, className = "", xs, sm, md, lg, xl, xxl, ...props }) {
  const uid = useId().replace(/:/g, "");
  const rowId = `row-${uid}`;

  const bpValues = { xs, sm, md, lg, xl, xxl };
  const hasColCounts = BREAKPOINTS.some((bp) => bpValues[bp] !== undefined);

  let cssRules = "";

  if (hasColCounts) {
    for (const bp of BREAKPOINTS) {
      const val = bpValues[bp];
      if (val === undefined) continue;

      const minW = BP_MIN_WIDTH[bp];
      const pct = `${100 / val}%`;
      const rule = `  .${rowId} > * { flex: 0 0 auto !important; width: ${pct} !important; max-width: ${pct} !important; }`;

      if (minW === 0) {
        cssRules += rule + "\n";
      } else {
        cssRules += `@media (min-width: ${minW}px) {\n${rule}\n}\n`;
      }
    }
  }

  return (
    <>
      {cssRules && <style dangerouslySetInnerHTML={{ __html: cssRules }} />}
      <div
        className={`flex flex-wrap -mx-[15px] ${hasColCounts ? rowId : ""} ${className}`.trim()}
        {...props}
      >
        {children}
      </div>
    </>
  );
}
